import React from "react";
import { t } from "ttag";

import { AppBadgesBlock as Value } from "@reactivated";

import appStoreBadge from "../../../static/img/app-store-badge.svg";
import googlePlayBadge from "../../../static/img/google-play-badge.svg";

import styles from "./index.module.scss";

interface Props {
    value: Value;
}

export const AppBadgesBlock = (props: Props) => {
    if (!props.value.app_store_url && !props.value.google_play_url) {
        return null;
    }
    return (
        <div className={styles.container}>
            {props.value.app_store_url && (
                <a href={props.value.app_store_url}>
                    <img
                        className={styles.image}
                        alt={t`Download on the App Store`}
                        src={props.value.app_store_image?.url ?? appStoreBadge}
                    />
                </a>
            )}
            {props.value.google_play_url && (
                <a href={props.value.google_play_url}>
                    <img
                        className={styles.image}
                        alt={t`Get it on Google Play`}
                        src={
                            props.value.google_play_image?.url ??
                            googlePlayBadge
                        }
                    />
                </a>
            )}
        </div>
    );
};
